var map = {
	"./1.3.0": 75181,
	"./1.3.0/": 75181,
	"./1.3.0/CrossChainDispatcher": 59810,
	"./1.3.0/CrossChainDispatcher.json": 59810,
	"./1.3.0/DebtToken": 5811,
	"./1.3.0/DebtToken.json": 5811,
	"./1.3.0/DepositToken": 31872,
	"./1.3.0/DepositToken.json": 31872,
	"./1.3.0/FeeProvider": 57795,
	"./1.3.0/FeeProvider.json": 57795,
	"./1.3.0/NativeTokenGateway": 95055,
	"./1.3.0/NativeTokenGateway.json": 95055,
	"./1.3.0/Pool": 32820,
	"./1.3.0/Pool.json": 32820,
	"./1.3.0/PoolRegistry": 36902,
	"./1.3.0/PoolRegistry.json": 36902,
	"./1.3.0/Quoter": 10666,
	"./1.3.0/Quoter.json": 10666,
	"./1.3.0/SmartFarmingManager": 46450,
	"./1.3.0/SmartFarmingManager.json": 46450,
	"./1.3.0/SyntheticToken": 17454,
	"./1.3.0/SyntheticToken.json": 17454,
	"./1.3.0/index": 75181,
	"./1.3.0/index.js": 75181,
	"./1.3.2": 15471,
	"./1.3.2/": 15471,
	"./1.3.2/CrossChainDispatcher": 37008,
	"./1.3.2/CrossChainDispatcher.json": 37008,
	"./1.3.2/DebtToken": 37527,
	"./1.3.2/DebtToken.json": 37527,
	"./1.3.2/DepositToken": 91840,
	"./1.3.2/DepositToken.json": 91840,
	"./1.3.2/FeeProvider": 64914,
	"./1.3.2/FeeProvider.json": 64914,
	"./1.3.2/NativeTokenGateway": 24476,
	"./1.3.2/NativeTokenGateway.json": 24476,
	"./1.3.2/Pool": 54357,
	"./1.3.2/Pool.json": 54357,
	"./1.3.2/PoolRegistry": 30151,
	"./1.3.2/PoolRegistry.json": 30151,
	"./1.3.2/Quoter": 38354,
	"./1.3.2/Quoter.json": 38354,
	"./1.3.2/SmartFarmingManager": 69198,
	"./1.3.2/SmartFarmingManager.json": 69198,
	"./1.3.2/SyntheticToken": 49870,
	"./1.3.2/SyntheticToken.json": 49870,
	"./1.3.2/index": 15471,
	"./1.3.2/index.js": 15471,
	"./LayerZeroCustomEvents": 14329,
	"./LayerZeroCustomEvents.json": 14329,
	"./MerkleV2Abi": 97677,
	"./MerkleV2Abi.json": 97677,
	"./StargateComposer": 90731,
	"./StargateComposer.json": 90731,
	"./StargateFactory": 49197,
	"./StargateFactory.json": 49197,
	"./StargatePool": 98116,
	"./StargatePool.json": 98116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89619;